import { Switch } from "../../../atoms";
import { DragHandleIcon } from "../../../atoms/icons/DragHandleIcon";

export const AppSettingsOption = {
  Separator: () => <div className="w-full border-t border-gray-200" />,
  Handle: () => (
    <div data-swapy-handle className="">
      <DragHandleIcon className="size-5 text-gray-950" />
    </div>
  ),
  Container: ({ children }: { children: React.ReactNode }) => (
    <div className="bg-gray-0 flex flex-row items-center gap-2 rounded-xl border border-gray-200 p-3">
      {children}
    </div>
  ),
  Label: ({ children }: { children: React.ReactNode }) => (
    <div className="text-sm font-medium text-gray-950">{children}</div>
  ),
  Switch: (props: React.ComponentProps<typeof Switch>) => (
    <Switch
      {...props}
      thumbClassName="size-3 data-[state=checked]:ml-[calc(100%-.75rem-1px)]"
      className="h-4 w-8"
    />
  ),
};
